import serverCode from '../../serverCode'

const defaultState = () => ({
  items: null,
})

const state = defaultState()

const getters = {}

const mutations = {
  setItems(state, payload) {
    state.items = payload
  },
  resetItems(state) {
    Object.assign(state, defaultState())
  },
}

const actions = {
  async getItems({ commit, rootState }) {
    try {
      const rv = await serverCode('getReportArticleTop', {}, rootState.locale)
      if (!rv.succeed) {
        throw new Error()
      } else {
        commit('setItems', rv)
      }
    } catch (error) {
      //
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
